module.exports = __webpack_public_path__ + "vueDist/img/receive-btn.906218f7.png";